import { dev } from '../framework/config'

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

type GetLoggerOpts = {
  logLevel?: LogLevel
  metadata?: Record<string, unknown>
  onLog?: (level: LogLevel, ...msgs: unknown[]) => void
}

const DEFAULT_LOG_LEVEL: LogLevel = dev ? 'debug' : 'info'

export const getLogger = (name: string, opts?: GetLoggerOpts) => {
  const log_level = opts?.logLevel ?? DEFAULT_LOG_LEVEL

  return {
    debug: (...msgs: unknown[]) => {
      if (!shouldDebug(log_level)) return
      if (opts?.metadata) {
        msgs.push(opts.metadata)
      }
      // eslint-disable-next-line no-console
      console.debug(`[${name}]`, ...msgs)
      opts?.onLog?.(log_level, ...msgs)
    },
    info: (...msgs: unknown[]) => {
      if (!shouldInfo(log_level)) return
      if (opts?.metadata) {
        msgs.push(opts.metadata)
      }
      // eslint-disable-next-line no-console
      console.info(`[${name}]`, ...msgs)
      opts?.onLog?.(log_level, ...msgs)
    },
    warn: (...msgs: unknown[]) => {
      if (!shouldWarn(log_level)) return
      if (opts?.metadata) {
        msgs.push(opts.metadata)
      }
      // eslint-disable-next-line no-console
      console.warn(`[${name}]`, ...msgs)
      opts?.onLog?.(log_level, ...msgs)
    },
    error: (...msgs: unknown[]) => {
      if (!shouldError(log_level)) return
      if (opts?.metadata) {
        msgs.push(opts.metadata)
      }
      // eslint-disable-next-line no-console
      console.error(`[${name}]`, ...msgs)
      opts?.onLog?.(log_level, ...msgs)
    },
  }
}

const shouldDebug = (level: LogLevel) => {
  return level === 'debug'
}

const shouldInfo = (level: LogLevel) => {
  return level === 'debug' || level === 'info'
}

const shouldWarn = (level: LogLevel) => {
  return level === 'debug' || level === 'info' || level === 'warn'
}

const shouldError = (level: LogLevel) => {
  return (
    level === 'debug' ||
    level === 'info' ||
    level === 'warn' ||
    level === 'error'
  )
}
